import React from 'react';
import MiniPDPInterstitialAsync from 'yoda-mini-pdp/lib/components/MiniPDPInterstitial/MiniPDPInterstitialAsync';

/* istanbul ignore next */
const renderMiniPDP = (MfeLoading = null) => (
    <>
        {MfeLoading && <MfeLoading />}
        <MiniPDPInterstitialAsync />
    </>
);
export default renderMiniPDP;
